import { createAction } from '@ngrx/store';

const TAG = '[Engine]';

export const stopRuntimeAndResetElementsState = createAction(
  `${TAG} Stop runtime and reset elements`,
);

export const resetEngineState = createAction(`${TAG} Reset engine state`);
